import { FacetCountsDTO, MappedFacetCounts } from "./filters.type";

export const mapFacetCounts = (results: FacetCountsDTO): MappedFacetCounts => {
  const counts = results.facetItems.map(
    (item) =>
      item.key !== "" && {
        filterKey: item.key,
        filterValues: item.values.map(
          (val) =>
            val.description !== "" && {
              name: val.description,
              count: val.count,
            }
        ),
      }
  );
  const additionalInformation = results.additionalInformation;
  return { counts: counts, additionalInformation: additionalInformation };
};
